import { render } from "./Finish.vue?vue&type=template&id=5bc1b40f"
import script from "./Finish.vue?vue&type=script&lang=js"
export * from "./Finish.vue?vue&type=script&lang=js"
script.render = render

export default script